import {
    GET_SUBADMIN,
    GET_SUBADMIN_SUCCESS,
    GET_SUBADMIN_FAILURE,
    CREATE_PERMISSION,
    CREATE_PERMISSION_SUCCESS,
    CREATE_PERMISSION_FAILURE,
    UPDATE_PERMISSION,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_FAILURE,
    UPDATE_SUBADMIN,
    UPDATE_SUBADMIN_SUCCESS,
    UPDATE_SUBADMIN_FAILURE,
    VIEW_SUBADMIN_FAILURE,
    VIEW_SUBADMIN_SUCCESS,
    VIEW_SUBADMIN
  } from "../types";
  
  export const SubadminList = (payload) => ({
    type: GET_SUBADMIN,
    payload,
  });
  export const SubadminListSuccess = (payload) => ({
    type: GET_SUBADMIN_SUCCESS,
    payload,
  });
  export const SubadminListFailure = (payload) => ({
    type: GET_SUBADMIN_FAILURE,
    payload,
  });
  
  export const createPermission = (payload) => ({
    type: CREATE_PERMISSION,
    payload,
  });
  export const createPermissionSuccess = (payload) => ({
    type: CREATE_PERMISSION_SUCCESS,
    payload,
  });
  export const createPermissionFailure = (payload) => ({
    type: CREATE_PERMISSION_FAILURE,
    payload,
  });
  
  export const updatePermission = (payload) => ({
    type: UPDATE_PERMISSION,
    payload,
  });
  export const updatePermissionSuccess = (payload) => ({
    type: UPDATE_PERMISSION_SUCCESS,
    payload,
  });
  export const updatePermissionFailure = (payload) => ({
    type: UPDATE_PERMISSION_FAILURE,
    payload,
  });
  
  export const updateSubadmin = (payload) => ({
    type: UPDATE_SUBADMIN,
    payload,
  });
  export const updateSubadminSuccess = (payload) => ({
    type: UPDATE_SUBADMIN_SUCCESS,
    payload,
  });
  export const updateSubadminFailure = (payload) => ({
    type: UPDATE_SUBADMIN_FAILURE,
    payload,
  });

  export const viewSubadmin = (payload) => ({
    type: VIEW_SUBADMIN,
    payload,
  });
  
  export const viewSubadminSuccess = (payload) => ({
    type: VIEW_SUBADMIN_SUCCESS,
    payload,
  });
  
  export const viewSubadminFailure = (payload) => ({
    type: VIEW_SUBADMIN_FAILURE,
    payload,
  });